import { Component, ChangeDetectionStrategy, input, output, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyModalComponent {
  isOpen = input.required<boolean>();
  initialTab = input<'tos' | 'pdpa'>('tos');
  
  closeModal = output<void>();
  accept = output<void>();

  activeTab = signal<'tos' | 'pdpa'>('tos');

  constructor() {
      effect(() => {
        // When the modal is opened, set the active tab based on the input
        if(this.isOpen()) {
            this.activeTab.set(this.initialTab());
        }
      });
  }

  onClose() {
    this.closeModal.emit();
  }

  acceptAndClose() {
    this.accept.emit();
    this.onClose(); // The accept event just triggers the parent, then we close
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
